// 通过spuId和skuId获取商品的详细信息
import { getSpuInfoApi, getSkuInfoApi, isAllowedSellApi, getInstallmentApi, isGroupAllowedApi } from './api'
import config from '@/config'
import app from '@/utils/app'
import env from 'utils/clientEnv'
import { stringify } from 'qs'
import { grouponEndPopup } from '@/components'

export const getProductInfo = async ({ spuId, skuId, operateType, channel }) => {
  const [spuInfo, skuInfo] = await Promise.all([
    getSpuInfoApi(spuId, operateType, channel),
    getSkuInfoApi({ spuId, skuId, operateType, channel })
  ])
  return {
    spuInfo,
    skuInfo: skuInfo[skuId]
  }
}
// 获取spu信息
export const getSpuInfo = spuId => {
  return getSpuInfoApi(spuId).then(
    res => res,
    err => {
      app.toast(err && err.msg)
      return new Promise(() => {})
    }
  )
}
// 获取sku信息
export const getSkuInfo = ({ spuId, skuId, typeId, operateType, channel }) => {
  return getSkuInfoApi({ spuId, skuId, typeId, operateType, channel }).then(
    res => res,
    err => {
      app.toast(err && err.msg)
    }
  )
}

// 拼装提交参数
export const getSelectParams = ({ operateType, channel, selectData, skuInfo, spuInfo, grouponId }) => {
  let data = {}
  data.skuId = selectData.skuId
  // 服务商品要带上机型参数
  if (skuInfo.typeId === 3) {
    data.num = 1
    data.imei = (spuInfo && spuInfo.commons && spuInfo.commons.imei) || ''
    data.authenticationCode = (spuInfo.commons && spuInfo.commons.emmcid) || ''
    return data
  }
  // 数量
  data.num = selectData.number

  // 已选服务
  let service = selectData.service
  if (service && Object.keys(service).length) {
    data.sSkuIds = Object.values(service).map(item => item.id)
  }
  // 已选套餐
  let suiteId = selectData.currentSuite && selectData.currentSuite.id
  if (suiteId) {
    data.id = suiteId
    data.suiteCode = suiteId
    const bundleSkus = selectData.currentSuite.bundleSkus
    if (bundleSkus && bundleSkus.length) {
      data.bSkuIds = bundleSkus.map(item => {
        return item.id
      })
    }
  }

  // 花呗分期数
  data.fqNum = selectData.fqNum || 0

  // 是否选中镭雕
  data.laser = selectData.laser || false

  // 如果是拼团，则携带grouponId参数
  if (operateType == 2) {
    data.grouponId = grouponId || 0
    data.channel = channel
  }

  return data
}

/**
 * 购买流程，不同operateType代表不同的购买类型
 * operateType 1 正常购买， 2 拼团， 3 拼团活动的单独购买， 4 抢购
 * @param {*} param0
 */
export const confirmBuy = async ({ instance, operateType, channel, params = {}, selectData, skuInfo, spuInfo }) => {
  let checkedParams = getSelectParams({
    operateType,
    channel,
    selectData,
    skuInfo,
    spuInfo,
    grouponId: params.grouponId
  })
  // 拼购校验
  if (operateType == 2) {
    // 活动信息从spu中获取
    const actInfo = spuInfo.grouponActInfos[skuInfo.id] || {}
    // 拼团商品
    await checkGrouponState({
      instance,
      selectData,
      spuInfo,
      skuInfo,
      params: {
        skuId: checkedParams.skuId,
        num: checkedParams.num,
        suiteCode: checkedParams.suiteCode,
        promotionId: actInfo && actInfo.promotionId,
        grouponId: params.grouponId || 0,
        channel
      }
    })
  } else {
    // 常规校验
    await checkCommonState(checkedParams)
  }
  // 校验分期
  if (checkedParams.fqNum) {
    await getInstallmentApi({
      skuId: checkedParams.skuId,
      money: selectData.totalPrice
    })
  }
  // 去结算页结算
  toSettle(checkedParams)
}

// 正常商品购买校验
const checkCommonState = async params => {
  return isAllowedSellApi(params).then(
    res => {},
    err => {
      app.toast(err && err.msg)
      setTimeout(() => {
        window.location.reload()
      }, 3000)
      // 校验失败后打断流程
      return new Promise(() => {})
    }
  )
}
// 拼团商品购买校验
const checkGrouponState = ({ instance, params, selectData, spuInfo, skuInfo }) => {
  return isGroupAllowedApi(params).then(
    res => {
      const status = res.status // 0 成功， 1 活动结束， 2 活动无库存

      if (status === 0) {
        return true
      } else if (status == 1 || status == 2) {
        instance.close()
        grouponEndPopup({
          result: res,
          selectData,
          spuInfo,
          skuInfo
        })
      } else {
        app.toast(res.message)
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      }
      return new Promise(() => {})
    },
    res => {
      app.toast(res && res.msg)
      return new Promise(() => {})
    }
  )
}

/**
 * 进入结算流程
 * @param {*} param0
 */
export const toSettle = async params => {
  if (params.laser) {
    params.sourceReferUrl = env.isBankabc ? encodeURIComponent(location.href) : location.href
    location.href = config.path.shopUrl + '/laser/confirm?jump_native=false&' + stringify(params, { indices: false })
  } else {
    location.href = config.path.shopUrl + '/order/quick/confirm?jump_native=false&' + stringify(params, { indices: false })
  }
}
